import { Skeleton } from '../../../../feedback/Skeleton';
import { Flex, FlexProps } from '../../../../layout/Flex';
import { Wrapper } from '../../styles';

export const AdvertisingProductCardSkeleton: React.FC<FlexProps> = (props) => (
    <Wrapper height="326px" {...props}>
        <Flex flexShrink={0} width="100%">
            <Skeleton variant="rect" width="100%" height={185} borderRadius={3} />
        </Flex>
        <Flex width="100%" p={0.5} height="100%">
            <Flex spacing={0.5} width="100%" p={0.5}>
                <Skeleton variant="rect" width="95%" height={20} borderRadius={1} />
                <Skeleton variant="rect" width="50%" height={20} borderRadius={1} />
                <Skeleton variant="rect" width="70%" height={20} borderRadius={1} />
            </Flex>
            <Skeleton variant="rect" width="100%" mt="auto" height={40} borderRadius={3} />
        </Flex>
    </Wrapper>
);
